import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { Input } from '../../../../input'
import { FONTS } from '../../../../../constants'
import { saleProductSelector } from '../../../../../selectors'
import { formatNumber } from '../../../../../function/math'

export const credit_term = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '90', value: '90' },
]

export const InputRow = (props) => {
  const [saleProducts, setSaleProducts] = useState([])
  const _saleProducts = useSelector(saleProductSelector.getSaleProductList)

  const {
    idx,
    vendor,
    handleInput,
  } = props

  useEffect(() => {
    setSaleProducts(_saleProducts.map(p => {
      return {
        label: p.name,
        value: p._id,
      }
    }))
  }, [_saleProducts])

  const saleProduct = saleProducts.find(p => p.value === vendor.product_id)
  const creditTerm = credit_term.find(t => t.value === vendor.credit_term)

  return (
    <Root>
      <InputWrapper>
        <Input
          name='sub_project_code'
          placeholder='Enter Sub-Project Code'
          value={ vendor.sub_project_code }
          onChange={ e => handleInput({ vendor_id: vendor.vendor_id, sub_project_code: e.target.value }, 'vendors', idx) }
        />
      </InputWrapper>
      <Text>{ saleProduct ? saleProduct.label : '-' }</Text>
      <Text>{ vendor.description || '-' }</Text>
      <Text>{ vendor.delivery_date ? moment(vendor.delivery_date).format('DD/MM/YYYY') : '-' }</Text>
      <Text>{ creditTerm ? creditTerm.label : '-' }</Text>
      <Number>{ formatNumber(vendor.cost) || '-' }</Number>
      <Number>{ formatNumber(vendor.price) || '-' }</Number>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 46px;
  display: grid;
  align-items: center;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 2fr 1fr 1fr 1fr 1fr;
  padding: 0 24px;
  background: #FFFFFF;
  margin-bottom: 1px;
`

const InputWrapper = styled.div`
  position: relative;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`

const Number = styled(Text)`
  text-align: right;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-other-service/input-row.js